import script from "./HrListAddBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./HrListAddBtn.vue?vue&type=script&setup=true&lang=js"

import "./HrListAddBtn.vue?vue&type=style&index=0&id=023c6254&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-023c6254"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QItem});
